import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c082bc7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "background-color": "white",
    "padding": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "巡检管理", -1));
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": "2",
      onAddMore: _cache[0] || (_cache[0] = $event => $data.createVisible = true),
      onOnDetailData: $options.onDetailClick
    }, {
      state: _withCtx(data => [_createTextVNode(_toDisplayString(data.mapping[data.rowData]), 1)]),
      resultLetter: _withCtx(data => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $event => $options.viewReport(data.data.id)
      }, {
        default: _withCtx(() => [_createTextVNode("查看")]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }, 8, ["onOnDetailData"])]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    "visible-control": $data.reportViewVisible,
    onClose: _cache[1] || (_cache[1] = $event => $data.reportViewVisible = false),
    width: "450px",
    title: "查看告知单"
  }, {
    default: _withCtx(() => [$data.reportViewVisible ? (_openBlock(), _createElementBlock("iframe", {
      key: 0,
      src: $data.reportUrl,
      style: {
        "width": "100%",
        "height": "600px"
      }
    }, null, 8, _hoisted_3)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}